<template>
  <v-container class="docs">
    <portal to="content-before">
      <OrsInnerToolbar
        title="Documentos"
        title-icon="mdi-file-document"
      />
    </portal>
    <v-row
      v-if="isLoading"
      justify="center"
      class="mt-8"
    >
      <v-progress-circular indeterminate />
    </v-row>
    <v-row
      v-else-if="noResults"
      justify="center"
      class="mt-8"
    >
      <h3>
        Nenhum documento encontrado.
      </h3>
    </v-row>
    <template v-else>
      <OrsTimeline :dense="$vuetify.breakpoint.smAndDown">
        <OrsTimelineItem
          v-for="(period, periodIdx) in limitedPeriods"
          :key="periodIdx"
          :title="formatPeriod(period)"
          color="primary"
        >
          <v-row
            v-for="(doc, docIdx) in period.arquivos"
            :key="docIdx"
            class="docs-period"
          >
            <v-col
              cols="2"
              style="min-width: 95px;"
            >
              <v-input label="Tipo">
                {{ doc.tipoArquivoApp }}
              </v-input>
            </v-col>
            <v-col
              cols="4"
            >
              <v-input label="Arquivo">
                {{ doc.nomeArquivo }}
              </v-input>
            </v-col>
            <v-col
              cols="4"
            >
              <v-input label="Empresa">
                {{ doc.compArquivo }}
              </v-input>
            </v-col>
            <v-col
              cols="2"
            >
              <v-btn
                outlined
                rounded
                small
                href="#"
                @click.prevent="downloadURI(doc.urlDownload, doc.nomeArquivo)"
              >
                Download
                <v-icon
                  small
                  class="ml-1"
                >
                  mdi-download
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="!period.show && period.ultimosArquivos && period.ultimosArquivos.length">
            <v-col class="text-center">
              <v-btn
                text
                color="primary"
                @click="period.show = true"
              >
                Ver mais
              </v-btn>
            </v-col>
          </v-row>
          <div v-if="period.show">
            <v-row
              v-for="(doc, docIdx) in period.ultimosArquivos"
              :key="docIdx"
              class="docs-period"
            >
              <v-col
                cols="2"
                style="min-width: 95px;"
              >
                <v-input label="Tipo">
                  {{ doc.tipoArquivoApp }}
                </v-input>
              </v-col>
              <v-col
                cols="4"
              >
                <v-input label="Arquivo">
                  {{ doc.nomeArquivo }}
                </v-input>
              </v-col>
              <v-col
                cols="4"
              >
                <v-input label="Empresa">
                  {{ doc.compArquivo }}
                </v-input>
              </v-col>
              <v-col
                cols="2"
              >
                <v-btn
                  outlined
                  rounded
                  small
                  href="#"
                  @click.prevent="downloadURI(doc.urlDownload, doc.nomeArquivo)"
                >
                  Download
                  <v-icon
                    small
                    class="ml-1"
                  >
                    mdi-download
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </OrsTimelineItem>
      </OrsTimeline>
      <div
        v-if="!noMoreResults"
        class="d-flex justify-center ma-4"
      >
        <v-btn
          color="primary"
          elevation="0"
          rounded
          @click="loadMorePeriods"
        >
          Ver mais
        </v-btn>
      </div>
    </template>
  </v-container>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.0/FileSaver.min.js"></script>
<script>
import { createNamespacedHelpers } from 'vuex';
import OrsInnerToolbar from '@/components/OrsInnerToolbar.vue';
import OrsTimeline from '../components/OrsTimeline.vue';
import OrsTimelineItem from '@/components/OrsTimelineItem.vue';
import saveAs from '../lib/downloadFile';

const session = createNamespacedHelpers('session');
const docs = createNamespacedHelpers('views/documents');

export default {
  name: 'Documents',
  components: {
    OrsInnerToolbar,
    OrsTimeline,
    OrsTimelineItem,
  },
  computed: {
    ...docs.mapGetters([
      'isLoading',
      'noResults',
      'noMoreResults',
    ]),
    ...docs.mapGetters([
      'limitedPeriods',
    ]),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.loadPeriods();
      vm.addAccountChangeListener(vm.loadPeriods);
    });
  },
  beforeRouteLeave(to, from, next) {
    this.removeAccountChangeListener(this.loadPeriods);
    next();
  },
  methods: {
    ...session.mapMutations([
      'addAccountChangeListener',
      'removeAccountChangeListener',
    ]),
    ...docs.mapActions([
      'loadPeriods',
      'loadMorePeriods',
      'download',
    ]),
    formatPeriod(period) {
      const str = (period.competencia || '');
      return `Competência ${str.substr(5, 2)}/${str.substr(0, 4)}`;
    },
    downloadURI(uri, name) {
      const oReq = new XMLHttpRequest();
      oReq.open('GET', uri, true);
      oReq.responseType = 'blob';
      oReq.onload = function () {
        const file = new Blob([oReq.response], {
          type: 'application/pdf',
        });
        saveAs(file, name);
      };

      oReq.send();
    },
    getTipo(doc) {
      const url = doc.urlDownload || '';
      const available = [
        'OUTROS', 'GRF', 'GPS', 'PCC', 'RTRET', 'FOPAG',
        'RET', 'RE', 'ERE', 'RFE', 'RFEF', 'RIPT',
        'RAGRF', 'RAGPS', 'IRRF',
        'DIRF', 'CONECSOCIAL',
      ];
      const regex = new RegExp(`^.*(${available.join('|')}).*$`, 'gm');
      const result = url.toUpperCase().replace(regex, '$1');
      if (result === '' || result === 'ERE') {
        return 'OUTROS';
      }
      if (result === 'RE/') {
        return 'RE';
      }
      return result;
    },
  },
};
</script>
